import { useEffect, useState } from "react";

import VisaChancesAccordion from "../../../sub_components/student/visa-chances/VisaChancesAccordion";

import { ChanceResultDisplay, IChanceResult } from "../../../../interfaces/services";

interface IVisaChancesListProps {
    chanceResults: IChanceResult[];
    filter: ChanceResultDisplay;
}

const VisaChancesList = (props: IVisaChancesListProps) => {
    const { chanceResults, filter } = props;

    const [results, setResults] = useState(chanceResults);

    useEffect(() => {
        const newResults = chanceResults.filter((result: IChanceResult) => result.display === filter).filter((result: IChanceResult) => result.display !== ChanceResultDisplay.NONE);

        setResults(newResults);
    }, [filter, chanceResults]);

    return (
        <div className='immersion__visa_chances__chances_list'>
            {!results.length && <p className='immersion__visa_chances__chances_list__empty_text'>No results found</p>}
            {results.map((result: IChanceResult) => (
                <VisaChancesAccordion
                    key={result.id}
                    chanceResult={result}
                />
            ))}
        </div>
    )
};
export default VisaChancesList;